// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input {
  border-width: 0;
  background-color: white;
  border-radius: 7px 0px 0px 7px !important;
}

.search-btn {
  border-radius: 0px 7px 7px 0px !important;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/SearchPanel/SearchPanel.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,uBAAA;EACA,yCAAA;AACJ;;AACA;EACI,yCAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCAAA;AAEJ","sourcesContent":[".search-input {\n    border-width: 0;\n    background-color: white;\n    border-radius: 7px 0px 0px 7px !important;\n}\n.search-btn {\n    border-radius: 0px 7px 7px 0px !important;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n    background-color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
